/**
 * OfflineIndicator — shows a banner when the browser goes offline.
 *
 * Listens to `navigator.onLine` and window online/offline events.
 * Auto-dismisses 3 seconds after coming back online.
 */

import { useEffect, useState } from 'react';
import { Alert, Collapse } from '@mui/material';
import { WifiOff as WifiOffIcon } from '@mui/icons-material';

export default function OfflineIndicator() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showReconnect, setShowReconnect] = useState(false);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => {
      setIsOffline(false);
      setShowReconnect(true);
      setTimeout(() => setShowReconnect(false), 3000);
    };

    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  return (
    <>
      <Collapse in={isOffline}>
        <Alert
          severity="warning"
          icon={<WifiOffIcon />}
          sx={{ borderRadius: 0, justifyContent: 'center' }}
        >
          You are currently offline. Some features may be unavailable.
        </Alert>
      </Collapse>
      <Collapse in={showReconnect}>
        <Alert
          severity="success"
          sx={{ borderRadius: 0, justifyContent: 'center' }}
        >
          Back online!
        </Alert>
      </Collapse>
    </>
  );
}
